import { DataLayer } from "@grandvisionhq/analytics";
import { myAccountEventType } from "./types.js";
const logSocialLoginEvent = (event) => {
  DataLayer.pushEvent({
    event_type: myAccountEventType,
    event: event.type,
    ..."action" in event ? { action: event.action } : null,
    ..."errorMessage" in event ? { action: event.errorMessage } : null
  });
};
export {
  logSocialLoginEvent
};
//# sourceMappingURL=social-login.js.map
